module.exports = __webpack_public_path__ + "img/bg_login.7715e1e9.png";